/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Redo</h4>

<p>Redo the last operation.</p>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>Ctrl-Y</b>: Redo</li>
</ul>`;

export default function RedoTooltip() {
    return h('div', { innerHTML: body });
}
